export default "__VITE_ASSET__2qBpzDcK__"